var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.322 4.67C7.561 2.86 9.474 2 12 2s4.44.86 5.678 2.67c1.197 1.751 1.683 4.281 1.683 7.455 0 1.441.006 2.383.21 3.145.188.695.55 1.262 1.377 1.878A.75.75 0 0120.5 18.5h-3.957C15.7 20.759 13.906 22 12 22c-1.906 0-3.7-1.241-4.543-3.5H3.5a.75.75 0 01-.448-1.352c.828-.616 1.19-1.183 1.376-1.878.205-.762.21-1.704.21-3.145 0-3.174.487-5.704 1.684-7.455zM9.09 18.5c.698 1.387 1.849 2 2.91 2 1.061 0 2.212-.613 2.91-2H9.09zM7.56 5.517c-.94 1.374-1.42 3.533-1.42 6.608v.084c0 1.334 0 2.475-.262 3.45-.131.489-.325.93-.6 1.341h13.446a4.46 4.46 0 01-.6-1.34c-.262-.976-.262-2.117-.262-3.451v-.084c0-3.076-.482-5.234-1.421-6.608C15.54 4.203 14.149 3.5 12 3.5s-3.541.703-4.44 2.017z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.7915f413d8e867e2392732e546b62aaf.svg";
export { ForwardRef as ReactComponent };